import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { switchMap, catchError, throwError, map, forkJoin, of } from 'rxjs';
import {
  DOWNLOAD_RENDICONTAZIONE,
  RETRIEVE_RENDICONTAZIONI, RETRIEVE_RENDICONTAZIONI_SUCCESS,
} from './rendicontazione.actions';
import { ResponseRendicontazioni } from '../../interfaces/response-rendicontazione';
import { DOWNLOAD_FILE } from '../config/config.actions';

@Injectable()
export class RendicontazioniEffects {
  retrieveRendicontazioni$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RENDICONTAZIONI),
      switchMap(() => {
        return this.api.retrieveRendicontazione();
      }),
      map((rendicontazioni: ResponseRendicontazioni) => {
        return RETRIEVE_RENDICONTAZIONI_SUCCESS({rendicontazioni})
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadRendicontazione$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_RENDICONTAZIONE),
      switchMap(({ payload }: { payload: string }) => {
        return forkJoin({
          request: of(payload),
          response: this.api.downloadRendicontazione(payload)
        })
      }),
      map(({request, response}: {request: string, response: Blob}) => {
        return DOWNLOAD_FILE({file: response, fileName: request})
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  constructor(private actions$: Actions, private api: ApiService) {}
}
